import React from 'react';
import gPremiumBrand from '../images/GPremium-brand@2x.png';
import styles from '../score.module.scss'

// 底部log
const Footer = () => <div className={styles.footLog}>
    <img className={styles.footerImage} src={gPremiumBrand} alt="公司log"/>
</div>

export default Footer;